import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import SwipeableViews from 'react-swipeable-views';
import EditIcon from '@material-ui/icons/Edit';
import EditPriceModal from './Modals/EditPriceModal';
import {
  makeStyles,
  useTheme,
  Card,
  Typography,
  Grid,
  Box,
  AppBar,
  Tabs,
  Tab,
  Fab
} from '@material-ui/core/';
import {
  defaultPriceByDate,
  defaultInfoText,
  defaultPriceList
} from '../defaultData';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }  

const useStyles = makeStyles(() => ({
    root: {
      maxWidth: 500,
      maxHeight: 430,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      marginTop: '-8%',
      zIndex:2,
      textAlign: 'center',
      padding: '2% 0%',
      overflow: 'auto',
    },
    iconStyle: {
      alignSelf: 'center',
      margin: '0% 3%',
    },
    marBot: {
      marginBottom: '14%',
    },
    gridItem: {
      width: '80%',
    },
    shadowless: {
        boxShadow: 'none !important',
    }
  }));

  function PriceList({ admin, API }) {
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [priceListId, setPriceListId] = useState('');
    const [priceByDate, setPriceByDate] = useState(defaultPriceByDate);
    const [priceList, setPriceList] = useState(defaultPriceList);
    const [infoText, setInfoText] = useState(defaultInfoText)

    useEffect(() => {
      function fetchPriceList() {
        return new Promise( resolve => {
            axios.get(`${API}priceList`)
              .then( res => {
                resolve(res.data);
              })
              .catch(err => console.log(err));
        })
      };
  
      async function loadPriceList() {
          const result = await fetchPriceList();
          setPriceByDate(result[0].priceByDate);
          setPriceList(result[0].priceList);
          setInfoText(result[0].infoText);
          setPriceListId(result[0]._id);
      };

      loadPriceList();
    }, [API]);


    const handleEditPriceModal = () => setIsModalOpen(!isModalOpen);

    const handleChange = (event, newValue) => {
        setValue(newValue);
      };
    
    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const props = {
      priceByDate,
      setPriceByDate,
      priceList,
      setPriceList,
      infoText,
      setInfoText,
      onClose: handleEditPriceModal,
      priceListId,
      API,
    }

    return(
        <Card className={classes.root}>
            <Grid container justify='center' direction='column'>
              {
                (admin && admin.username) &&               
                  <Fab 
                  color="primary" 
                  size='small' 
                  aria-label="edit"
                  style={{ 
                    alignSelf: 'flex-end', 
                    marginRight: '2vw',
                    position: 'absolute',
                  }}
                  onClick={() => handleEditPriceModal()}
                >
                  <EditIcon />
                </Fab>
              }

              <Typography variant="h2" color='textSecondary' >
                  Ceník
              </Typography>
            </Grid>
            <Grid container justify='center' >
            <Typography variant="body1" color='textSecondary' >Ceny v termínu</Typography>

                {
                  isModalOpen && <EditPriceModal {...props} />
                }

                <AppBar className={classes.shadowless} position="static" color="transparent">
                    <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="full width tabs"
                    >
                    <Tab style={{fontSize: 'large'}} label={priceByDate.beforeSeason} {...a11yProps(0)} />
                    <Tab style={{fontSize: 'large'}} label={priceByDate.season} {...a11yProps(1)} />
                    <Tab style={{fontSize: 'large'}} label={priceByDate.afterSeason} {...a11yProps(2)} />
                    </Tabs>
                </AppBar>
                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                >
                    <TabPanel value={value} index={0} dir={theme.direction}>
                      <Typography variant="body1" color='textPrimary'>
                        {priceList.outSeason.text}
                      </Typography>
                      <Typography variant="body1" color='textSecondary'>
                        {priceList.outSeason.price}
                      </Typography>
                    </TabPanel>
                    <TabPanel value={value} index={1} dir={theme.direction}>
                      <Typography variant="body1" color='textPrimary'>
                        {priceList.season.text}
                      </Typography>
                      <Typography variant="body1" color='textSecondary'>
                        {priceList.season.price}
                      </Typography>
                    </TabPanel>
                    <TabPanel value={value} index={2} dir={theme.direction}>
                        <Typography variant="body1" color='textPrimary'>
                          {priceList.outSeason.text}
                        </Typography>
                      <Typography variant="body1" color='textSecondary'>
                          {priceList.outSeason.price}
                      </Typography>
                    </TabPanel>
                </SwipeableViews>
            </Grid>

            <Typography className={classes.gridItem} variant="body1" color='textPrimary'>
                {infoText.lineOne}<br />
                {infoText.lineTwo}<br /><br />
                {infoText.footerLine}
            </Typography>
        </Card>
    )
  }

  export default PriceList;